var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoSymbol(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 52 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7761 30.1519C21.9695 31.0286 22.2428 32.7358 21.1372 33.7213C19.7893 34.9228 18.1933 35.8297 16.4502 36.3701C13.8481 37.1766 11.0561 37.1235 8.48644 36.2185C5.9168 35.3136 3.70574 33.6047 2.17976 31.3443C0.653779 29.0839 -0.106228 26.3918 0.0119648 23.6655C0.130158 20.9392 1.12029 18.3232 2.83614 16.2039C4.552 14.0846 6.90262 12.5742 9.5409 11.8959C12.1792 11.2175 14.9653 11.4072 17.4877 12.4367C19.1775 13.1264 20.3677 14.0656 21.6065 15.3796C22.6227 16.4574 22.5241 18.2376 21.2593 19.0072C19.9945 19.7769 18.3645 19.3175 17.1953 18.4087C16.6702 18.0005 16.089 17.6633 15.4659 17.4089C14.008 16.8139 12.3978 16.7043 10.873 17.0963C9.34827 17.4884 7.98974 18.3613 6.99808 19.5861C6.00641 20.811 5.43418 22.3228 5.36587 23.8985C5.29756 25.4741 5.7368 27.03 6.61873 28.3364C7.50066 29.6428 8.77852 30.6304 10.2636 31.1534C11.7487 31.6764 13.3623 31.7071 14.8662 31.241C15.509 31.0417 16.1172 30.7562 16.6757 30.3952C17.9191 29.5914 19.5827 29.2753 20.7761 30.1519Z",
    fill: "url(#paint0_linear_2211_8394)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7761 30.1519C21.9695 31.0286 22.2428 32.7358 21.1372 33.7213C19.7893 34.9228 18.1933 35.8297 16.4502 36.3701C13.8481 37.1766 11.0561 37.1235 8.48644 36.2185C5.9168 35.3136 3.70574 33.6047 2.17976 31.3443C0.653779 29.0839 -0.106228 26.3918 0.0119648 23.6655C0.130158 20.9392 1.12029 18.3232 2.83614 16.2039C4.552 14.0846 6.90262 12.5742 9.5409 11.8959C12.1792 11.2175 14.9653 11.4072 17.4877 12.4367C19.1775 13.1264 20.3677 14.0656 21.6065 15.3796C22.6227 16.4574 22.5241 18.2376 21.2593 19.0072C19.9945 19.7769 18.3645 19.3175 17.1953 18.4087C16.6702 18.0005 16.089 17.6633 15.4659 17.4089C14.008 16.8139 12.3978 16.7043 10.873 17.0963C9.34827 17.4884 7.98974 18.3613 6.99808 19.5861C6.00641 20.811 5.43418 22.3228 5.36587 23.8985C5.29756 25.4741 5.7368 27.03 6.61873 28.3364C7.50066 29.6428 8.77852 30.6304 10.2636 31.1534C11.7487 31.6764 13.3623 31.7071 14.8662 31.241C15.509 31.0417 16.1172 30.7562 16.6757 30.3952C17.9191 29.5914 19.5827 29.2753 20.7761 30.1519Z",
    fill: "#31639A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6012 7.23874C16.6279 1.56438 22.8623 -1.38954 28.5261 0.640976C34.1899 2.67149 37.1383 8.91752 35.1115 14.5919C33.0848 20.2662 26.8504 23.2201 21.1867 21.1896C15.5229 19.1591 12.5745 12.9131 14.6012 7.23874ZM30.0778 12.7872C31.1097 9.89814 29.6085 6.71797 26.7248 5.68414C23.8411 4.65031 20.6669 6.15429 19.635 9.04338C18.6031 11.9325 20.1042 15.1126 22.9879 16.1465C25.8716 17.1803 29.0459 15.6763 30.0778 12.7872Z",
    fill: "url(#paint1_linear_2211_8394)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6012 7.23874C16.6279 1.56438 22.8623 -1.38954 28.5261 0.640976C34.1899 2.67149 37.1383 8.91752 35.1115 14.5919C33.0848 20.2662 26.8504 23.2201 21.1867 21.1896C15.5229 19.1591 12.5745 12.9131 14.6012 7.23874ZM30.0778 12.7872C31.1097 9.89814 29.6085 6.71797 26.7248 5.68414C23.8411 4.65031 20.6669 6.15429 19.635 9.04338C18.6031 11.9325 20.1042 15.1126 22.9879 16.1465C25.8716 17.1803 29.0459 15.6763 30.0778 12.7872Z",
    fill: "#31639A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9513 11.696C12.1781 11.4698 10.3755 11.6319 8.66853 12.1729C7.64317 12.4979 6.66805 12.9546 5.76651 13.529C4.60731 14.2677 4.58942 15.8712 5.54376 16.8612C6.4981 17.8513 8.06767 17.8294 9.31612 17.255C9.59261 17.1278 9.90787 17.2303 10.1995 17.1379C11.2856 16.7936 12.5164 16.7468 13.6419 16.9233C14.7149 17.0915 15.9653 17.65 16.8455 18.3794C15.3514 16.6583 14.1277 13.964 13.9513 11.696Z",
    fill: "url(#paint2_linear_2211_8394)",
    fillOpacity: 0.8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2032 19.2024C28.6752 12.2814 36.2793 8.67847 43.1874 11.1551C50.0955 13.6317 53.6917 21.25 51.2197 28.171C48.7477 35.092 41.1436 38.6949 34.2355 36.2183C27.3274 33.7417 23.7312 26.1234 26.2032 19.2024ZM45.9254 26.273C47.3511 22.2814 45.2771 17.8876 41.2929 16.4592C37.3087 15.0309 32.9231 17.1088 31.4974 21.1004C30.0718 25.092 32.1458 29.4858 36.13 30.9142C40.1142 32.3425 44.4997 30.2646 45.9254 26.273Z",
    fill: "url(#paint3_linear_2211_8394)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2032 19.2024C28.6752 12.2814 36.2793 8.67847 43.1874 11.1551C50.0955 13.6317 53.6917 21.25 51.2197 28.171C48.7477 35.092 41.1436 38.6949 34.2355 36.2183C27.3274 33.7417 23.7312 26.1234 26.2032 19.2024ZM45.9254 26.273C47.3511 22.2814 45.2771 17.8876 41.2929 16.4592C37.3087 15.0309 32.9231 17.1088 31.4974 21.1004C30.0718 25.092 32.1458 29.4858 36.13 30.9142C40.1142 32.3425 44.4997 30.2646 45.9254 26.273Z",
    fill: "#31639A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.657 13.9077C31.372 12.351 33.4633 11.2647 35.7111 10.7528C35.7006 10.1551 35.6417 9.55794 35.5342 8.96713C35.2748 7.54098 34.7375 6.17998 33.953 4.96185C33.1686 3.74372 32.1524 2.69232 30.9623 1.86768L27.9802 6.18716C28.6041 6.61946 29.1368 7.17063 29.548 7.8092C29.9593 8.44777 30.2409 9.16124 30.3769 9.90886C30.5129 10.6565 30.5006 11.4236 30.3407 12.1665C30.2084 12.7811 29.9772 13.3691 29.657 13.9077Z",
    fill: "url(#paint4_linear_2211_8394)",
    fillOpacity: 0.7
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.44 19.1807C30.4647 20.1542 27.9863 21.0192 25.7835 21.0014C25.625 21.776 25.5329 22.5647 25.5094 23.3589C25.4557 25.1665 25.758 26.9671 26.399 28.6577C27.0399 30.3483 28.0069 31.8959 29.2448 33.2121L33.2366 29.4437C32.4926 28.6527 31.8345 27.7133 31.4493 26.6973C31.0641 25.6812 30.8764 24.7094 30.9086 23.6231C30.9409 22.5367 31.1863 21.4673 31.6311 20.476C31.7589 20.1911 32.2323 19.4529 32.44 19.1807Z",
    fill: "url(#paint5_linear_2211_8394)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.4743 10.5862C34.0867 10.9884 31.8384 12.0253 29.9796 13.5864C29.5318 14.2824 28.9483 14.8593 28.2792 15.2949C27.3599 16.4005 26.6014 17.6723 26.0535 19.0881C25.706 19.9862 25.4601 20.8986 25.3102 21.8126C28.2041 21.7649 30.9814 20.6018 33.048 18.5861C33.1248 18.5056 33.2031 18.4269 33.283 18.35C34.3064 17.2911 35.1398 16.0141 35.705 14.5535C36.2099 13.2488 36.4581 11.9077 36.4743 10.5862Z",
    fill: "#31639A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2211_8394",
    x1: 11.1482,
    y1: 11.4966,
    x2: 11.1482,
    y2: 36.9384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.328121,
    stopColor: "#31639A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2211_8394",
    x1: 24.8564,
    y1: -7.86379e-8,
    x2: 24.8564,
    y2: 21.8306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.328121,
    stopColor: "#31639A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2211_8394",
    x1: 15.6866,
    y1: 13.5477,
    x2: 10.0272,
    y2: 13.9097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.800762,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2211_8394",
    x1: 38.7114,
    y1: 10.3733,
    x2: 38.7114,
    y2: 37.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.328121,
    stopColor: "#31639A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2211_8394",
    x1: 33.5781,
    y1: 11.2633,
    x2: 30.7234,
    y2: 6.30899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2211_8394",
    x1: 29.1168,
    y1: 21.331,
    x2: 29.6785,
    y2: 27.095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSymbol);
export default __webpack_public_path__ + "static/media/logo-symbol.c847eb37f2eee7cd3262696a42510e02.svg";
export { ForwardRef as ReactComponent };